import { AppBar, AppBarProps, Stack, StackProps } from '@mui/material';

type Props = AppBarProps & { stackProps?: StackProps };

export const BottomAppBar = ({ children, stackProps, ...rest }: Props) => {
  return (
    <AppBar
      position="sticky"
      color={'transparent'}
      sx={(theme) => ({
        top: 'auto',
        bottom: 0,
        background: `linear-gradient(to top, ${theme.palette.background.default}, 80%, transparent)`,
      })}
      variant={'elevation'}
      {...rest}
    >
      <Stack
        direction={{ xs: 'column-reverse', md: 'row' }}
        flexWrap={'wrap'}
        gap={2}
        justifyContent={{ md: 'space-between', xs: 'center' }}
        pb={{ xs: 2, md: 6 }}
        px={6}
        {...stackProps}
      >
        {children}
      </Stack>
    </AppBar>
  );
};
